export const networks = [2000]

export const ChainId = {
  DOGECHAIN: 2000
};

export const dogechainRouter = "0x4450aDcC4BCb82a04085D51f956dF4138c907cFE";

export const routerAddress = new Map();
routerAddress.set(ChainId.DOGECHAIN, dogechainRouter);